export default "<li class=\"search-suggest-history-item\">\n  <span class=\"suggest-key\"></span>\n</li>\n"